import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import styled from 'styled-components'

import logoColor from 'assets/logoColor.png'

interface ModalProps {
  open: boolean
}

export const ModalWindowSizeWarning = ({ open }: ModalProps) => {
  return (
    <DialogBox
      sx={{
        boxShadow: `0 4px 4px -1px ${({
          theme
        }: {
          theme: Record<string, any>
        }) => theme.colors.black}`
      }}
      open={open}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle
        id='alert-dialog-title'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '16px',
          textAlign: 'center'
        }}
      >
        <LogoWrapper>
          <Logo src={logoColor} alt='logo' />
        </LogoWrapper>
        <p>Window size is smaller than minimum requirements</p>
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center' }}>
        <p>
          Your current window size is too small. Please expand the width of your
          browser window to at least 1280px to use the application.
        </p>
      </DialogContent>
    </DialogBox>
  )
}

const DialogBox = styled(Dialog)`
  .MuiBackdrop-root {
    background-color: ${({ theme }) => theme.colors.modalBackdropDark};
  }
  .MuiPaper-root {
    padding: 16px;
  }
  .MuiDialog-container,
  .MuiDialog-scrollPaper {
    @media (max-width: 768px) {
      width: 100vw !important;
      height: 100vh !important;
    }
  }
`
const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`
const Logo = styled.img`
  height: ${({ theme }) => theme.dimensions.logoColorHeight + 'px'};
`
